import React from 'react';
import { Tag as AntdTag, TagProps } from 'antd';
import styled from '@emotion/styled';

const StyledTag = styled(AntdTag)`
  padding: 4px 6px 4px 8px;
  gap: 4px;
  background: rgba(78, 90, 113, 1);
  border-radius: 13px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.005em;
  color: white;
  display: flex;
  align-items: center;
  .ant-tag-close-icon {
    width: 25px;
    height: 25px;
    margin-left: 8px;
    > span {
      color: white;
      font-size: 12px;
    }
  }
`;

const Tag = (props: TagProps) => {
  return <StyledTag {...props}></StyledTag>;
};

export default Tag;
